import React from 'react';
import HeaderBar from './components/HeaderBar';
import QuickUpload from './components/QuickUpload';
import FooterPrivacyNote from './components/FooterPrivacyNote';
import ProgressIndicator from './components/ProgressIndicator';

function App() {
  return (
    <div className="min-h-screen bg-white font-arial">
      <HeaderBar />
      <div className="max-w-xl mx-auto px-4 py-8">
        <ProgressIndicator />
        <QuickUpload />
        <FooterPrivacyNote />
      </div>
    </div>
  );
}

export default App;